<template>
  <div style="background: #f4f5f4;">
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="explain-body">
      <ul class="explain-ul">
        <li class="explain-li" v-for="(item,index) in explainList" :key="index"
        :class="{on:explainDirector == index}" @click="selectItem(index)">
          <i class="explain-i" :class="'explain-i'+index"></i>{{item}}
        </li>
      </ul>
      <router-view></router-view>
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
    @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
    @changeLoginState="changeLoginState"></SuspendMember>
  </div>
</template>
<script>
  import Header from '../../components/common/Header';
  import Footer from "../../components/common/Footer";
  import SuspendSide from "../../components/SuspendSide";
  import SuspendMember from '../../components/SuspendMember';
  export default {
    name: "explain",
    components: { Footer, Header, SuspendSide,SuspendMember},
    metaInfo(){
      return {
        title:"101游戏_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    asyncData({store,route}){
      return store.dispatch('initSeo',{store:store});
    },
    computed:{
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      }
    },
    data() {
      return {
        explainDirector:0,
        explainList:[
          "防沉迷系统","游戏纠纷处理","用户服务协议",
          "用户隐私政策","家长监护","技术安全保障措施",
          "角色交易服务协议"
        ],
        suspendState:false,
        suspendType:0,
        loginState:false
      };
    },
    methods: {
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      selectItem(value){
        if(this.explainDirector != 3){
          if(this.explainDirector == value){
            return;
          }
        }
        this.explainDirector = value;
        switch(value){
          case 0:
            this.$router.push({name:'system'});
            break;
          case 1:
            this.$router.push({name:'dispute'});
            break;
          case 2:
            this.$router.push({name:'protocol'});
            break;
          case 3:
            this.$router.push({name:'privacy'});
            break;
          case 4:
            this.$router.push({name:'tutelage'});
            break;
          case 5:
            this.$router.push({name:'safeguard'});  
            break;  
          case 6:
            this.$router.push({name:'deal'});
            break;
          case 7:
            this.$router.push({name:'entrust'});
            break;
        }
      },
      initItem(){
        let value = 0;
        switch(this.$route.path){
          case "/system":
            value = 0;
            break;
          case "/dispute":
            value = 1;
            break;
          case "/protocol":
            value = 2;
            break;
          case "/privacy":
          case "/cookie":
          case "/sdk":
            value = 3;
            break;
          case "/tutelage":
            value = 4;
            break;
          case "/safeguard":
            value = 5;
            break; 
          case "/deal":
            value = 6;  
            break;
          default:
            value = 0;
            break;
        }
        this.explainDirector = value;
      },
    },
    mounted(){
      this.initItem();
    }
  };
</script>
<style src="@/assets/css/explain.css" scoped></style>